const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * PAGE EVENTS                                                          *
\* -------------------------------------------------------------------------- */

/**
 * Push the page view event. It must be always the first one
 */
function pushPageView() {
  pushEvent(createCustomEventGA4('page_view', []));
}

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.pageLoadedDynamically, () => {
    pushEvent(createCustomEventGA4('page_view', []));
  });
}

module.exports = {
  pushPageView,
  subscribeToAnalyticsEvents,
};
